module.exports = __webpack_public_path__ + "img/index25.4bdd7631.png";